import useAxios from 'hooks/useAxios';

const emptyResponse = {
  data: [],
  meta: {
    totalItems: 0,
    itemCount: 0,
    itemsPerPage: 0,
    totalPages: 0,
    currentPage: 0
  }
};

export const getLeaderboards = async (limit = 20, page = 1) => {
  const api = useAxios();
  try {
    return (
      await api.get('/leaderboard', {
        params: { limit, page }
      })
    ).data;
  } catch (err) {
    console.error('Error fetching leaderboards', err);
    return emptyResponse;
  }
};

export const createLeaderboard = async (payload) => {
  const api = useAxios();
  try {
    return await api.post('/leaderboard', payload);
  } catch (err) {
    console.error('Error creating leaderboard', err);
    throw err;
  }
};

export const deleteLeaderboard = async (id) => {
  const api = useAxios();
  try {
    return await api.delete(`/leaderboard/${id}`);
  } catch (err) {
    console.error('Error deleting leaderboard', err);
    throw err;
  }
};

export const getLeaderboard = async (id) => {
  const api = useAxios();
  try {
    return (await api.get(`/leaderboard/${id}`)).data;
  } catch (err) {
    console.error('Error fetching leaderboard', err);
    return { data: null };
  }
};

export const getLeaderboardScores = async (leaderboardId, limit = 20, page = 1) => {
  const api = useAxios();
  try {
    return (
      await api.get(`/leaderboard/${leaderboardId}/scores`, {
        params: { limit, page }
      })
    ).data;
  } catch (err) {
    console.error('Error fetching leaderboard scores', err);
    return emptyResponse;
  }
};

export const getBetLimitsForGame = async (gameId) => {
  const api = useAxios();
  if (!gameId) return [];
  try {
    return (await api.get(`/bet-limit/for-game/${gameId}`)).data;
  } catch (err) {
    console.error('Error fetching bet limits for game', err);
    return [];
  }
};
